<template>
    <div class="tab-field">
        <h2 v-if=" ! isMobile">Информация о проекте</h2>

        <template v-loading="!isReady">
            <div class="selects">
                <div class="th-areas">
                    <!--                    <Hint hint="some toolTip"/>-->
                    <MultiSelect
                        class="multi-select"
                        label="Тематические направления"
                        :items="thematic_areas"
                        v-model="common.thematic_areas"
                    />
                </div>

                <div class="type-select">
                    <!--                    <Hint hint="some toolTip"/>-->
                    <select v-model="common.project_type">
                        <option :value="null" disabled>Тип проекта</option>

                        <option
                            v-for="(type, index) in project_types"
                            :key="index"
                            :value="type.id"
                        >{{ type.title }}</option>
                    </select>
                </div>
            </div>

            <div class="text-areas">
                <div class="area">
                    <!--                    <Hint hint="some toolTip"/>-->
                    <textarea placeholder="Цель" v-model="common.target"></textarea>
                </div>

                <div class="area middle">
                    <!--                    <Hint hint="some toolTip"/>-->
                    <textarea placeholder="Описание проекта" v-model="common.description"></textarea>
                </div>

                <div class="area">
                    <!--                    <Hint hint="some toolTip"/>-->
                    <textarea placeholder="Актуальность проекта" v-model="common.actuality"></textarea>
                </div>
            </div>
            <div class="files">
                <div class="files__passport">
                    <ModelFile
                        class="file-input"
                        label="Паспорт проекта"
                        v-model="passportFile"
                    ></ModelFile>
                    <a
                        class="dlfile"
                        :href="dlUrl"
                        download
                    >Скачать форму паспорта проекта</a>
                </div>
                <div class="files__docs">
<!--                    <div-->
<!--                        class="files__docs__item"-->
<!--                        v-for="(item, i) in common.files"-->
<!--                        :key="item.url"-->
<!--                    >-->
<!--                        <div class="files__docs__item__title">{{ item.file.name | file_name(35) }}</div>-->
<!--                        <div class="files__docs__item__close" @click="common.files.splice(i, 1)"></div>-->
<!--                    </div>-->
                    <ModelFile
                        class="file-input"
                        label="Добавить файлы"
                        v-model="common.files"
                        multiple
                    ></ModelFile>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import MultiSelect from "../../UI/inputs/MultiSelect";

// import Hint from './Hint';

import { mapGetters, mapActions } from "vuex";
import ModelFile from "../../UI/models/ModelFile";

const getters = ["project_types", "thematic_areas", "isMobile"];

const actions = ["loadContestsConfig"];

export default {
    name: "Common",
    props: {
        common: Object,
    },
    data: () => ({
        new_file: null,
        dlUrl: `http://s3-cms.rsv.ru/pasport_proyektnoi_initsiativy.docx`,
    }),
    mounted() {
        if (!this.common.files) {
            this.$set(this.common, "files", []);
        }
    },
    filters: {
        file_name(name, length) {
            if (name.length <= length) {
                return name;
            }

            let parts = name.split(".");
            let ext = "";
            if (parts.length > 1) {
                ext = `.${parts.pop()}`;
            }
            name = parts.join(".");
            name = name.slice(0, length - ext.length);
            return `${name}...${ext}`;
        },
    },
    computed: {
        ...mapGetters(getters),

        isReady() {
            return this.project_types.length && this.thematic_areas.length;
        },

        passportFile: {
            get() {
                return this.common.passport_file
                    ? { url: this.common.passport_file }
                    : null;
            },
            set(v) {
                this.$set(this.common, 'passport_file', v ? v.url : null);
            },
        },
    },
    watch: {
        new_file(file) {
            if (file) {
                this.common.files.push(file);
                this.new_file = null;
            }
        },
    },
    methods: {
        ...mapActions(actions),
    },
    model: {
        prop: "common",
        event: "change",
    },
    components: {
        ModelFile,
        MultiSelect,
        // Hint,
    },
    async created() {
        this.loadContestsConfig();
    },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/rem";
@import "../../../styles/mrem";

.selects,
.text-areas {
    display: flex;
}

.selects {
    > * {
        display: flex;
        flex-grow: 1;

        select {
            flex-grow: 1;
            background-color: #fff;
            font-size: 0.8rem;
            padding: 0 0.5rem;
        }
    }

    .type-select {
        margin-left: 2rem;

        select {
            border: 1px solid #b9b9b9;
            border-radius: 0.2rem;
        }
    }
}

.th-areas {
    width: 37rem;
    flex: none;
}

.multi-select {
    width: 35rem;
}

.text-areas {
    margin-top: 1rem;
}

.area {
    display: flex;
    flex-grow: 1;

    textarea {
        flex-grow: 1;
        font-size: 0.8rem;
        padding: 0.5rem 0.7rem;
        resize: none;
        height: 5rem;
        border:  1px solid #b9b9b9;
        border-radius: 0.2rem;
    }

    &.middle {
        margin: 0 2rem;
    }
}

.file-input {
    margin-top: 1rem;
    width: 24rem;
}

.files {
    display: flex;

    &__passport {
        flex: 1;
    }

    &__docs {
        flex: 2;
        margin: 1rem 2rem 0;

        .file-input {
            margin: 0;
        }

        &__item {
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 2rem;

            &__title {
                color: #4663AB;
            }

            &__close {
                width: 1rem;
                height: 1rem;
                background: url(../../../assets/images/close.png) no-repeat
                    center;
                background-size: 50%;
                cursor: pointer;
            }
        }
    }
}
.dlfile {
    margin-top: 20px;
    font-size: 12pt;
    color: #2c59ab;
}

@import "../../../styles/variables";

@media (max-width: $vm) {
    .selects {
        flex-direction: column;

        .type-select {
            height: mrem(48);
            margin-left: 0;
            margin-top: mrem(32);
            padding: mrem(13) mrem(14);
            border: solid mrem(1) #b9b9b9;
            border-radius: mrem(4);

            select {
                font-size: mrem(16);
                line-height: mrem(22);
                color: #98a0a9;
            }
        }
    }

    .th-areas {
        width: 100%;
    }

    .multi-select {
        width: 100%;
    }

    .text-areas {
        display: flex;
        flex-direction: column;
        margin-top: mrem(32);

        .area {
            margin-bottom: mrem(32);

            textarea {
                height: mrem(144);
                padding: mrem(9) mrem(16);
                border: mrem(1) solid #d2d5d9;
                border-radius: mrem(4);
                font-size: mrem(16);
                line-height: mrem(22);
                color: #98a0a9;

                &::placeholder {
                    color: #98a0a9;
                }
            }
        }

        .area.middle {
            margin-left: 0;
            margin-right: 0;
        }
    }
    .files {
        flex-direction: column;

        .file-input {
            width: 100%;
            margin-top: 0;
            margin-bottom: mrem(24);
        }

        .files__docs {
            margin: mrem(40) 0 0 0;

            &__item {
              width: 100%;
              padding-bottom: mrem(25);
            }

            &__item__title {
              font-size: mrem(14);
              line-height: mrem(17);
            }

            &__item__close {
              width: mrem(22);
              height: mrem(22);
            }
        }
    }
}
</style>

